// Enhanced Subscription Status Component with Styled Indicators
import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import './Navbar.css';
import { Skeleton } from '@mui/material';
import { Link } from 'react-router-dom';
import { RoutesFun } from '../../schemas';

const SubscriptionStatus = ({ user }: any) => {
  // Helper function to determine the status color based on remaining days
  const getStatusColorClass = (days: number) => {
    if (days > 15) return 'statusSuccess';
    if (days >= 10) return 'statusWarning';
    return 'statusDanger';
  };
  const Routes = RoutesFun();

  return user === undefined ? (
    <Skeleton width={'14rem'} height={'4.5rem'} style={{ marginLeft: '5px' }} />
  ) : (
    <div className="subscriptionStatusContainer">
      <Link to={Routes.Billing}
          onClick={(e) => {
          if (user?.RoleId !== 2) e.preventDefault(); // prevent navigation
        }}
        className={user?.RoleId !== 2 ? 'notAllowedCursor' : ''}>
        {user?.SubscriptionStatus === 'incomplete' ||
        user?.SubscriptionStatus === 'past_due' ? (
          <div className="paymentProcessing">
            <AccessTimeIcon className="processingIcon" />
            <span>Payment processing...</span>
          </div>
        ) : (
          <div
            className={`renewalStatus ${getStatusColorClass(
              user?.RemainingDays
            )}`}
          >
            {user?.SubscriptionMode === 'Auto Renewal'
              ? user && user?.RemainingDays === 0
                ? 'Renewing today'
                : user && user?.RemainingDays === 1
                ? 'Renew in 1 day'
                : `Renew in ${user?.RemainingDays} days`
              : user && user?.RemainingDays === 0
              ? 'Expiring today'
              : user?.RemainingDays === 1
              ? '1 day left'
              : `${user?.RemainingDays} days left`}
          </div>
        )}
      </Link>
    </div>
  );
};

export default SubscriptionStatus;
